module.exports = __webpack_public_path__ + "static/media/shapping_montage.86eee0d8.jpg";